import { useParams } from 'react-router-dom'

import InitialLoadWrapper from '@/components/util/InitialLoadWrapper'
import {
  fetchSubscriptionOrder,
  getError,
  getIsDataLoaded,
  getIsPending,
} from '@/ducks/subscriptionOrderReducer'

const withSubscriptionOrderLoaded =
  // @ts-ignore


    (Component, forceLoadOnMount = true) =>
    // @ts-ignore
    props => {
      const params = useParams()
      // @ts-ignore
      const orderId = parseInt(params.order_id)

      return (
        <InitialLoadWrapper
          loadAction={fetchSubscriptionOrder}
          loadingSelector={getIsPending}
          loadedSelector={getIsDataLoaded}
          errorSelector={getError}
          forceLoadOnMount={forceLoadOnMount}
          args={orderId}
        >
          <Component {...props} />
        </InitialLoadWrapper>
      )
    }

export default withSubscriptionOrderLoaded
